export enum PlayerMode {
    Stopped = 'stopped',
    FrameSeeking = 'frame-seeking',
    WaitingForPreviewFrameToLoad = 'waiting-for-preview-frame-load',
    WaitingForVideoToSeek = 'waiting-for-video-seek',
    WaitingForIdenticalVideoLoad = 'waiting-for-res-change-to-resume',
    PlayRequested = 'play-requested'
}
